export const FETCH_PUBLISHER_ANALYTICS = 'FETCH_PUBLISHER_ANALYTICS'
export const FETCH_SYSTEM_CONNECTOR_ACTIVITY = 'FETCH_SYSTEM_CONNECTOR_ACTIVITY'
export const FETCH_PUBLISHER_NOTIFICATION_LOGS = 'FETCH_PUBLISHER_NOTIFICATION_LOGS'
